exports.lang = {
    "kr": "zh-TW",
    "아프리카TV | 투표" : "AfreecaTV ㅣ 投票",
    "투표" : "投票",
    "투표 등록" : "製作新投票",
    "투표 수정" : "修改",
    "투표 등록 및 수정" : "製作並修改投票",
    "종류" : "分類",
    "기본형" : "基本型",
    "1:1 투표" : "1對1投票",
    "제목" : "標題",
    "투표 제목을 입력해주세요." : "請輸入標題。",
    "항목을 입력해주세요." : "請輸入選項內容。",
    "기간" : "期間",
    "투표 종료일" : "投票截止日",
    "종료일" : "截止日",
    "설정" : "設定",
    "복수 선택 허용" : "可多選",
    "결과 미리보기 허용" : "允許預覽結果",
    "체크 박스를 해제하시면 투표에 참여하기 전 또는 투표가 종료될 때까지 모든 참여자가 투표 결과를 확인할 수 없습니다." : "解除此選項，參與投票前或投票結束之前，所有用戶無法確認投票結果。",
    "수정" : "修改",
    "닫기" : "關閉",
    "삭제" : "刪除",
    "등록" : "製作",
    "투표 항목을 입력해주세요." : "請輸入選項內容。",
    "투표 항목은 최소 2개 이상 등록해야 합니다." : "選項不能少於兩個。",
    "투표는 최대 3개까지 등록할 수 있습니다." : "同時最多可進行3個投票。",
    "투표 항목은 최대 10개까지 만들 수 있습니다." : "投票選項不能超過10個。",
    "투표 제목은 최대 30자까지 입력할 수 있습니다." : "標題字數不能超過30字。",
    "투표 항목은 최대 10자까지 입력할 수 있습니다." : "選項內容不能超過10字。",
    "올바른 파일 형식이 아닙니다.\n파일 확장명이 JPG, GIF 인지 다시 확인해주세요." : "文件格式有誤。請確認文件擴展名是否為JPG, GIF後重新嘗試。",
    "파일 용량이 10MB을(를) 초과하여 등록할 수 없습니다." : "文件大小不能超過10MB。",
    "선택하신 GIF 파일 용량이 200KB를 초과하여 등록할 수 없습니다. 파일 용량을 다시 확인해주세요." : "您選擇的GIF文件超過200KB，無法上傳。請確認文件大小後重新嘗試。",
    "투표 기간을 설정해주세요." : "請設定投票期間。",
    "오늘보다 이전 날짜 또는 시간은 설정할 수 없습니다." : "不能設定過去的時間。",
    "입력하신 내용이 모두 초기화됩니다. 투표 형식을 변경하시겠습니까?" : "如要繼續，您輸入的所有內容都將被初始化。確定更改投票的形式嗎？",
    "투표가 수정되었습니다." : "修改成功。",
    "투표를 삭제하시겠습니까?" : "確定要刪除投票嗎？",
    "해당 투표 항목을 삭제하시겠습니까?" : "確定刪除此選項嗎？",
    "투표하기" : "投票",
    "결과 미리보기" : "預覽結果",
    "다시 투표하기" : "重新投票",
    "전체 참여자" : "累計參與",
    "명" : "",
    "투표하러 가기" : "去投票",
    "현재시간 이후를 선택해주세요." : "請選擇此刻以後的時間。",
    "투표 종료일을 3개월 이내로 선택해주세요." : "請選擇自投票開始後3月內的投票截止日期。",
    "투표가 등록되었습니다." : "新一輪投票開始。",
    "투표를 등록한 유저가 삭제한 투표입니다." : "此投票已被製作投票的用戶刪除。",
    "다른 투표에 참여해주세요." : "請參與其他投票。",
    "투표에 참여 완료되었습니다." : "參與成功。",
    "투표 종료" : "投票結束",
    "투표를 종료하시겠습니까?" : "確定結束投票嗎？",
    "항목 추가" : "添加選項",
    "취소" : "取消",
    "시" : "時",
    "분" : "分",
    "이미지 1:1 투표 등록 시, 투표 이미지를 모두 첨부하셔야 등록할 수 있습니다.": "進行圖片1:1投票時，須添加所有投票圖片才可進行。",
    "무승부" : "領帶",
    "무승부 항목 추가" : "添加平局",
}